import React, { useState } from 'react';
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../contexts/AuthContext'
import { dedupedRequest } from '../utils/axios';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const PasswordRequest = () => {
  // const navigate = useNavigate();
  // const { login } = useAuth();
  // const { login, isAuthenticated, user, token } = useAuth();
  // const { isAuthenticated, user } = useAuth();

  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (loading) return; // Prevent multiple submissions
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      const res = await dedupedRequest<{ access_token: string }>(
        {
          method: 'POST',
          url: '/password/request-reset',           // baseURL '/api' is applied in axios.ts
          data: { email },
          headers: { 'Content-Type': 'application/json' },
        },
        { useCache: false, maxRetries: 0 } // no caching; avoid retries on bad creds
      );
      const status = res.status;
      if (status !== 202) {
        throw new Error('Passwortanforderung fehlgeschlagen.');
      } else {
        setSuccess('Eine E-Mail zum Zurücksetzen des Passworts wurde gesendet.');
      }
    } catch (err: any) {
      // Axios errors often have response.data with details
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.detail ||
        err?.message ||
        'Login failed';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col md="auto">
          <form onSubmit={handleSubmit}>
            <Card style={{ width: '24rem' }}>
              <Card.Body>
                <Card.Title><h3>Passwort vergessen</h3></Card.Title>
                  <div data-mdb-input-init className="form-outline mb-2">
                  {/* <p>Link für neues Passwort versenden an:</p> */}
                    <input
                      className='form-control'
                      id="EmailInput"
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="E-Mail-Adresse"
                      required
                    />
                  </div>
                  <button type="submit" data-mdb-button-init data-mdb-ripple-init className="btn btn-primary btn-block mb-4">Abschicken</button>
                  {error && <p style={{ color: 'red' }}>{error}</p>}
                  {success && <p style={{ color: 'green' }}>{success}</p>}
              </Card.Body>
            </Card>
          </form>
        </Col>
      </Row>
    </Container>
  );
};

export default PasswordRequest;
